/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './about.component.scss.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as import3 from '@angular/material';
import * as import4 from '../../../../src/app/shared/type-it.directive';
import * as import5 from '../../../../src/app/about/about.component';
import * as import6 from '../../../../src/app/core/scroll.service';
import * as import7 from '../../../../src/app/core/contact.service';
import * as import8 from '../../../../src/app/core/destroyer.service';
const styles_AboutComponent:any[] = [import0.styles];
export const RenderType_AboutComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_AboutComponent,
  data: {}
}
);
export function View_AboutComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    import1.ɵqud(201326592,1,{card: 0}),
      (l()(),import1.ɵeld(0,(null as any),(null as any),22,'md-card',[[
        'class',
        'card'
      ]
      ],[[
        2,
        'mat-card',
        (null as any)
      ]
    ],(null as any),(null as any),import2.View_MdCard_0,import2.RenderType_MdCard)),
      import1.ɵdid(8192,(null as any),0,import3.MdPrefixRejector,[[
        2,
        import3.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    import1.ɵdid(24576,(null as any),0,import3.MdCard,([] as any[]),(null as any),(null as any)),
    import1.ɵdid(2105344,[
      [
        1,
        4
      ]
      ,
      [
        'card',
        4
      ]

    ]
      ,0,import4.TypeItDirective,[import1.ElementRef],{autoStart: [
        0,
        'autoStart'
      ]
    },(null as any)),
      (l()(),import1.ɵeld(0,(null as any),0,3,'md-card-title',[[
        'class',
        'title'
      ]
      ],[[
        2,
        'mat-card-title',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
      import1.ɵdid(8192,(null as any),0,import3.MdPrefixRejector,[[
        2,
        import3.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    import1.ɵdid(8192,(null as any),0,import3.MdCardTitle,([] as any[]),(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
      (l()(),import1.ɵeld(0,(null as any),0,3,'md-card-subtitle',[[
        'class',
        'subtitle'
      ]
      ],[[
        2,
        'mat-card-subtitle',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
      import1.ɵdid(8192,(null as any),0,import3.MdPrefixRejector,[[
        2,
        import3.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    import1.ɵdid(8192,(null as any),0,import3.MdCardSubtitle,([] as any[]),(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
      (l()(),import1.ɵeld(0,(null as any),0,3,'md-card-content',[[
        'class',
        'content'
      ]
      ],[[
        2,
        'mat-card-content',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
      import1.ɵdid(8192,(null as any),0,import3.MdPrefixRejector,[[
        2,
        import3.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    import1.ɵdid(8192,(null as any),0,import3.MdCardContent,([] as any[]),(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),[
      '',
      ''
    ]
    )),
      (l()(),import1.ɵeld(0,(null as any),0,6,'md-card-actions',([] as any[]),[[
        2,
        'mat-card-actions',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
      import1.ɵdid(8192,(null as any),0,import3.MdPrefixRejector,[[
        2,
        import3.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    import1.ɵdid(8192,(null as any),0,import3.MdCardActions,([] as any[]),(null as any),(null as any)),
    (l()(),import1.ɵeld(0,(null as any),(null as any),3,'a',[
      [
        'class',
        'github-button'
      ]
      ,
      [
        'href',
        'https://github.com/ksmai/'
      ]
      ,
      [
        'md-icon-button',
        ''
      ]
      ,
      [
        'target',
        '_new'
      ]

    ]
    ,[
      [
        1,
        'disabled',
        0
      ]
      ,
      [
        1,
        'aria-disabled',
        0
      ]
      ,
      [
        8,
        'tabIndex',
        0
      ]
      ,
      [
        2,
        'mat-icon-button',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,22)._haltDisabledEvents($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import2.View_MdAnchor_0,import2.RenderType_MdAnchor)),
      import1.ɵdid(8192,(null as any),0,import3.MdPrefixRejector,[[
        2,
        import3.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    import1.ɵdid(90112,(null as any),0,import3.MdAnchor,[
      import1.ElementRef,
      import1.Renderer,
      import3.FocusOriginMonitor
    ]
    ,(null as any),(null as any)),
    import1.ɵdid(8192,(null as any),0,import3.MdIconButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'button',[
      [
        'class',
        'project-button'
      ]
      ,
      [
        'color',
        'primary'
      ]
      ,
      [
        'md-raised-button',
        ''
      ]

    ]
    ,[
      [
        8,
        'disabled',
        0
      ]
      ,
      [
        2,
        'mat-raised-button',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import5.AboutComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.viewProjects()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import2.View_MdButton_0,import2.RenderType_MdButton)),
      import1.ɵdid(8192,(null as any),0,import3.MdPrefixRejector,[[
        2,
        import3.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    import1.ɵdid(90112,(null as any),0,import3.MdButton,[
      import1.ElementRef,
      import1.Renderer,
      import3.FocusOriginMonitor
    ]
      ,{color: [
        0,
        'color'
      ]
    },(null as any)),
    import1.ɵdid(8192,(null as any),0,import3.MdRaisedButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
    (l()(),import1.ɵted(0,['VIEW PROJECTS'])),
    (l()(),import1.ɵted((null as any),[' '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'button',[
      [
        'class',
        'destroy-button'
      ]
      ,
      [
        'color',
        'warn'
      ]
      ,
      [
        'md-raised-button',
        ''
      ]

    ]
    ,[
      [
        8,
        'disabled',
        0
      ]
      ,
      [
        2,
        'mat-raised-button',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import5.AboutComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.destroyPage()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import2.View_MdButton_0,import2.RenderType_MdButton)),
      import1.ɵdid(8192,(null as any),0,import3.MdPrefixRejector,[[
        2,
        import3.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    import1.ɵdid(90112,(null as any),0,import3.MdButton,[
      import1.ElementRef,
      import1.Renderer,
      import3.FocusOriginMonitor
    ]
      ,{color: [
        0,
        'color'
      ]
    },(null as any)),
    import1.ɵdid(8192,(null as any),0,import3.MdRaisedButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
    (l()(),import1.ɵted(0,['DESTROY THIS PAGE'])),
    (l()(),import1.ɵted((null as any),[' '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'button',[
      [
        'class',
        'skip-button'
      ]
      ,
      [
        'color',
        'accent'
      ]
      ,
      [
        'md-icon-button',
        ''
      ]

    ]
    ,[
      [
        8,
        'disabled',
        0
      ]
      ,
      [
        2,
        'mat-icon-button',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import5.AboutComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.skip()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import2.View_MdButton_0,import2.RenderType_MdButton)),
      import1.ɵdid(8192,(null as any),0,import3.MdPrefixRejector,[[
        2,
        import3.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    import1.ɵdid(90112,(null as any),0,import3.MdButton,[
      import1.ElementRef,
      import1.Renderer,
      import3.FocusOriginMonitor
    ]
      ,{color: [
        0,
        'color'
      ]
    },(null as any)),
    import1.ɵdid(8192,(null as any),0,import3.MdIconButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      (l()(),import1.ɵeld(0,(null as any),0,3,'md-icon',[[
        'role',
        'img'
      ]
      ],[[
        2,
        'mat-icon',
        (null as any)
      ]
    ],(null as any),(null as any),import2.View_MdIcon_0,import2.RenderType_MdIcon)),
      import1.ɵdid(8192,(null as any),0,import3.MdPrefixRejector,[[
        2,
        import3.MATERIAL_COMPATIBILITY_MODE
      ]
    ],(null as any),(null as any)),
    import1.ɵdid(4513792,(null as any),0,import3.MdIcon,[
      import1.ElementRef,
      import1.Renderer,
      import3.MdIconRegistry
    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted(0,['skip_next'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'background'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'overlay'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any)))
  ]
  ,(ck,v) => {
    const currVal_1:any = false;
    ck(v,4,0,currVal_1);
    const currVal_15:any = 'primary';
    ck(v,26,0,currVal_15);
    const currVal_18:any = 'warn';
    ck(v,32,0,currVal_18);
    const currVal_21:any = 'accent';
    ck(v,38,0,currVal_21);
    ck(v,42,0);
  },(ck,v) => {
    var co:import5.AboutComponent = v.component;
    const currVal_0:any = true;
    ck(v,1,0,currVal_0);
    const currVal_2:any = true;
    ck(v,5,0,currVal_2);
    const currVal_3:any = co.title;
    ck(v,8,0,currVal_3);
    const currVal_4:any = true;
    ck(v,9,0,currVal_4);
    const currVal_5:any = co.subtitle;
    ck(v,12,0,currVal_5);
    const currVal_6:any = true;
    ck(v,13,0,currVal_6);
    const currVal_7:any = co.content;
    ck(v,16,0,currVal_7);
    const currVal_8:any = true;
    ck(v,17,0,currVal_8);
    const currVal_9:any = import1.ɵnov(v,22).disabled;
    const currVal_10:any = import1.ɵnov(v,22)._isAriaDisabled;
    const currVal_11:any = import1.ɵnov(v,22).tabIndex;
    const currVal_12:any = true;
    ck(v,20,0,currVal_9,currVal_10,currVal_11,currVal_12);
    const currVal_13:any = import1.ɵnov(v,26).disabled;
    const currVal_14:any = true;
    ck(v,24,0,currVal_13,currVal_14);
    const currVal_16:any = import1.ɵnov(v,32).disabled;
    const currVal_17:any = true;
    ck(v,30,0,currVal_16,currVal_17);
    const currVal_19:any = import1.ɵnov(v,38).disabled;
    const currVal_20:any = true;
    ck(v,36,0,currVal_19,currVal_20);
    const currVal_22:any = true;
    ck(v,40,0,currVal_22);
  });
}
function View_AboutComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'port-about',([] as any[]),[[
        2,
        'typing-finished',
        (null as any)
      ]
    ],(null as any),(null as any),View_AboutComponent_0,RenderType_AboutComponent)),
    import1.ɵdid(2121728,(null as any),0,import5.AboutComponent,[
      import6.ScrollService,
      import3.MdDialog,
      import7.ContactService,
      import8.DestroyerService,
      import1.ElementRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import1.ɵnov(v,1).typingFinished;
    ck(v,0,0,currVal_0);
  });
}
export const AboutComponentNgFactory:import1.ComponentFactory<import5.AboutComponent> = import1.ɵccf('port-about',import5.AboutComponent,View_AboutComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./$$_gendir/src/app/about/about.component.ngfactory.ts